import React from 'react';
import Layout from '../../../shared/components/Layout';
import { Mail, Phone, MapPin, Send } from 'lucide-react';

const ContactPage: React.FC = () => {
  return (
    <Layout>
      <div className="bg-white">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-orange-500 via-red-500 to-pink-500 text-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                联系我们
              </h1>
              <p className="text-xl text-orange-100">
                我们随时准备为您提供帮助和支持
              </p>
            </div>
          </div>
        </section>

        {/* Contact Info */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-3 gap-8 mb-12">
                <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
                  <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Mail className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold mb-3">邮箱联系</h3>
                  <p className="text-gray-600 mb-2">商务合作</p>
                  <a
                    href="mailto:contact@runbuddy.cn"
                    className="text-orange-600 hover:text-orange-700 font-medium"
                  >
                    contact@runbuddy.cn
                  </a>
                  <p className="text-gray-600 mt-4 mb-2">投资咨询</p>
                  <a
                    href="mailto:investor@runbuddy.cn"
                    className="text-orange-600 hover:text-orange-700 font-medium"
                  >
                    investor@runbuddy.cn
                  </a>
                </div>

                <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
                  <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Phone className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold mb-3">电话联系</h3>
                  <p className="text-gray-600 mb-2">客服热线</p>
                  <a
                    href="tel:400-888-8888"
                    className="text-blue-600 hover:text-blue-700 font-medium text-lg"
                  >
                    400-888-8888
                  </a>
                  <p className="text-gray-500 text-sm mt-2">
                    工作时间: 9:00 - 18:00
                  </p>
                </div>

                <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
                  <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <MapPin className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold mb-3">公司地址</h3>
                  <p className="text-gray-600">
                    北京市朝阳区<br />
                    跑步产业园区<br />
                    跑伴大厦 8层
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-bold mb-4">
                  发送消息
                </h2>
                <p className="text-gray-600">
                  填写下方表单，我们会尽快回复您
                </p>
              </div>

              <form className="bg-gray-50 rounded-2xl p-8">
                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      姓名 *
                    </label>
                    <input
                      type="text"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      邮箱 *
                    </label>
                    <input
                      type="email"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                      placeholder="your@email.com"
                    />
                  </div>
                </div>

                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    电话
                  </label>
                  <input
                    type="tel"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                    placeholder="请输入您的电话号码"
                  />
                </div>

                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    咨询类型 *
                  </label>
                  <select
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  >
                    <option value="">请选择</option>
                    <option value="business">商务合作</option>
                    <option value="investor">投资咨询</option>
                    <option value="support">技术支持</option>
                    <option value="other">其他咨询</option>
                  </select>
                </div>

                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    消息内容 *
                  </label>
                  <textarea
                    required
                    rows={6}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                    placeholder="请详细描述您的问题或需求..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-4 rounded-lg font-bold hover:from-orange-600 hover:to-red-600 transition-all flex items-center justify-center"
                >
                  <Send className="w-5 h-5 mr-2" />
                  发送消息
                </button>
              </form>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
                常见问题
              </h2>

              <div className="space-y-4">
                <div className="bg-white rounded-xl p-6 shadow">
                  <h3 className="font-bold text-lg mb-2">如何成为跑伴的私兔？</h3>
                  <p className="text-gray-600">
                    您可以通过微信小程序注册账号，选择"私兔"角色，填写个人档案信息，包括跑步成绩、专业能力等。审核通过后即可开始接单。
                  </p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow">
                  <h3 className="font-bold text-lg mb-2">平台如何保障服务质量？</h3>
                  <p className="text-gray-600">
                    我们与元大都马拉松冠军俱乐部合作，所有私兔都经过专业认证。同时建立了完善的评价体系和投诉机制，确保服务质量。
                  </p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow">
                  <h3 className="font-bold text-lg mb-2">如何进行商务合作？</h3>
                  <p className="text-gray-600">
                    请发送邮件至 contact@runbuddy.cn 或拨打客服热线 400-888-8888，我们的商务团队会尽快与您联系。
                  </p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow">
                  <h3 className="font-bold text-lg mb-2">投资人如何了解更多信息？</h3>
                  <p className="text-gray-600">
                    您可以访问我们的<a href="/investor" className="text-orange-600 hover:text-orange-700 font-medium">投资人演示页面</a>，或发送邮件至 investor@runbuddy.cn 获取详细的商业计划书。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default ContactPage;
